import apimail from './apiemail';
import { apicode } from './apicode'

export const data_email = {




    async rsenha(email, senha) {


        const envio = await apicode._code({ email, senha });
       // console.log(envio , 'envio')

        const response = await apimail.post(`senhaenvia`, { envio: envio })
      //  console.log(response , 'response')


    },
}